import React__default from 'react';

const CardContext = React__default.createContext({
    image: undefined,
    imagePosition: "top",
});
const useCardContext = () => React__default.useContext(CardContext);

export { CardContext, useCardContext };
